/**
 * Constants for Enhanced Dashboard
 */

export const VALUATION_METHOD_MAP = {
  'cca': 'Comparable Company Analysis',
  'dcf': 'Discounted Cash Flow',
  'capitalization': 'Capitalization of Earnings',
  'nav': 'Net Asset Value',
  'manual': 'Manual Entry',
  'comprehensive': 'Comprehensive Analysis',
  'multiple_of_ebitda': 'Multiple of EBITDA',
  'sde': 'Seller\'s Discretionary Earnings'
};

export const SCORE_THRESHOLDS = {
  NO_GAPS: 86,
  MINOR_GAPS: 72,
  CONSIDERABLE_GAPS: 57,
  CRITICAL_GAPS: 43,
  VERY_CRITICAL_GAPS: 28
};

export const WEALTH_GAP_METHOD = {
  SINGLE_NUMBER: 'single_number',
  CASHFLOW_BASED: 'cashflow_based',
  NET_WORTH_BREAKDOWN: 'net_worth_breakdown'
};

export const DEFAULT_WEALTH_GAP_VALUES = {
  YEARS_OF_INCOME: '20',
  INFLATION_RATE: '3.0',
  RETURN_RATE: '7.0'
};
